var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo w-auto"},[_c('a',{staticClass:"text-xl font-bold font-heading"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"h-12",attrs:{"src":require("../assets/logo.webp"),"alt":"logo"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }